import clsx from 'clsx';
import type { FieldError } from 'react-hook-form';
import type { FieldValidationError } from 'types/cloud_api_error_type';

type FormErrorMessageProps = {
  formError: FieldError | FieldValidationError | undefined;
};

export const FormErrorMessage = ({ formError }: FormErrorMessageProps) => {
  return (
    <>
      {formError && (
        <ul className={clsx('parsley-errors-list', 'mg-t-5')}>
          <li>{formError.message}</li>
        </ul>
      )}
      <style>
        {`
          .parsley-errors-list {
            color: #dc3545;
            list-style: none;
            font-size: 12px;
            padding: 0;
            line-height: 1.5;
          }

          .mg-t-5 { margin-top: 5px; }
        `}
      </style>
    </>
  );
};
